/* LU - Guardian de video (21-sep-2026, pedido de Sebas: "como garantizas que los
   videos no se queden trabados, sin ralentizar absolutamente nada").
   UN solo archivo diferido (~7 KB sin comprimir) para TODOS los <video data-lu-vg>.

   Modos:
   - "full"   (Foto vs Video): el guardian manda. Arranca al verse >= 35 %, pausa al
               salir del todo o al ocultar la pestana, boton de play grande si el
               navegador veta el autoplay (clase is-blocked en la caja), tocar = reproducir.
   - "assist" (slider, Asi llega, Calidad): la seccion sigue mandando el play/pausa.
               El guardian solo elige la calidad, cae a otra si falla o se traba, y
               tocar el video quieto lo revive (salvo si tiene controles nativos).

   Que protege (todo medido 20/21-sep):
   1) CALIDAD: Liquid solo expone al tema el mp4 MAS GRANDE (1080p 4,8 Mbps en el
      slider). Aqui se deduce la 720p (o la 480p en cajas chicas o con ahorro de
      datos) del patron de nombres de Shopify. Escalones verificados con la API de
      archivos contra los 25 videos de la cuenta.
   2) ERROR de fuente (404, red caida a mitad): pasa al siguiente candidato desde el
      mismo segundo; si se acabaron, recarga una vez (por si la red volvio); si tampoco,
      en "full" muestra el play grande y en "assist" pone controles nativos.
   3) TRABADO (buffering > 4 s): baja a la calidad mas liviana desde el mismo segundo;
      si ya es la mas liviana, recarga una vez. Sin temporizadores mientras corre bien:
      el reloj solo nace con el evento 'waiting' y muere con 'playing'/'canplay'.
   4) TOQUE: un video quieto se reproduce al tocarlo; uno muerto reintenta desde el
      principio (gesto real del usuario = permiso de autoplay garantizado).
   5) Vuelta a la pestana o a la vista: se reanuda solo. Una pausa ajena (Dawn, el
      sistema) en modo "full" se autocura hasta 3 veces seguidas (el contador se limpia
      tras 2,5 s de reproduccion real); si algo insiste en pausarlo, queda quieto y el
      toque lo revive.
   Sin IntersectionObserver (navegadores viejos): en "full" arranca al cargar.
   El archivo es idempotente: si lo incluyen varias secciones, corre una sola vez. */
(function () {
  'use strict';
  if (window.__luVG) return;
  window.__luVG = true;

  var ESC1080 = { '2.5': ['1.6', '0.9'], '3.3': ['2.1', '1.0'], '4.8': ['3.0', '1.2'], '7.2': ['4.5', '1.5'] };
  var ESC720 = { '1.6': '0.9', '2.1': '1.0', '3.0': '1.2', '4.5': '1.5' };
  var conn = navigator.connection || {};
  var ahorro = !!conn.saveData || /^(slow-2g|2g|3g)$/.test(conn.effectiveType || '');
  var quieto = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var TRABON_MS = 4000;

  function deducir(url, alto) {
    var m = url.match(/\.HD-1080p-([\d.]+)Mbps-(\d+)\.mp4/);
    if (m && ESC1080[m[1]]) {
      var e = ESC1080[m[1]];
      return url.replace(m[0], alto === 720 ? '.HD-720p-' + e[0] + 'Mbps-' + m[2] + '.mp4' : '.SD-480p-' + e[1] + 'Mbps-' + m[2] + '.mp4');
    }
    var n = url.match(/\.HD-720p-([\d.]+)Mbps-(\d+)\.mp4/);
    if (n && alto === 480 && ESC720[n[1]]) return url.replace(n[0], '.SD-480p-' + ESC720[n[1]] + 'Mbps-' + n[2] + '.mp4');
    if (n && alto === 720) return url;
    return '';
  }
  function mbps(url) { var m = (url || '').match(/-([\d.]+)Mbps-/); return m ? parseFloat(m[1]) : 99; }

  function Guard(v) {
    var self = this;
    this.v = v;
    this.modo = v.getAttribute('data-lu-vg') === 'full' ? 'full' : 'assist';
    this.caja = v.parentNode;
    this.want = false; this.enVista = false; this.intent = false; this.reanudar = false;
    this.timer = 0; this.trabones = 0; this.recargas = 0; this.curas = 0; this.ultimaCura = 0;
    this.malas = {}; this.actual = ''; this.muerto = false; this.pausaNuestra = false;
    this.lista = this.candidatos();
    if (!this.lista.length) return;
    /* assist: la calidad se fija ANTES del primer play de la seccion. Con preload="none"
       asignar src no descarga nada. */
    if (this.modo === 'assist') this.poner(this.lista[0], 0, false);

    v.addEventListener('error', function () { self.fallo('error'); });
    v.addEventListener('waiting', function () { self.armar(); });
    v.addEventListener('stalled', function () { if (v.readyState < 3) self.armar(); });
    v.addEventListener('playing', function () { self.desarmar(); self.trabones = 0; self.clase(true); });
    /* el contador de autocuras solo se limpia tras 2,5 s de reproduccion real (timeupdate:
       ~4 veces por segundo, solo mientras corre; una comparacion, costo nulo) */
    v.addEventListener('timeupdate', function () { if (self.curas && Date.now() - self.ultimaCura > 2500) self.curas = 0; });
    v.addEventListener('canplay', function () { self.desarmar(); });
    v.addEventListener('play', function () { self.intent = true; });
    v.addEventListener('pause', function () {
      self.intent = false; self.desarmar();
      if (self.pausaNuestra) { self.pausaNuestra = false; return; }
      if (self.modo === 'full') self.autocura();
    });
    v.addEventListener('ended', function () { if (self.quiere()) self.play(); });
    this.caja.addEventListener('click', function (e) { self.toque(e); });
    document.addEventListener('visibilitychange', function () { self.visibilidad(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { self.vista(en); }); }, { threshold: [0, 0.35] }).observe(this.caja);
    } else if (this.modo === 'full') {
      this.enVista = true; this.want = true; this.arrancar();
    }
  }

  Guard.prototype.candidatos = function () {
    var v = this.v;
    var max = v.getAttribute('data-src-max') || '';
    if (!max) {
      var s = v.querySelector('source[type="video/mp4"]') || v.querySelector('source[src*=".mp4"]');
      if (s) max = s.getAttribute('src') || '';
    }
    if (!max) return [];
    var hd = v.getAttribute('data-src-hd') || deducir(max, 720);
    var sd = v.getAttribute('data-src-sd') || deducir(max, 480);
    var caja = (this.caja && this.caja.clientWidth) || v.clientWidth || 0;
    var chica = caja > 0 && caja * Math.min(window.devicePixelRatio || 1, 3) <= 280; /* 280 ~ ancho nativo de la 480p (270) */
    var l = [];
    if ((chica || ahorro) && sd) l.push(sd);
    if (hd) l.push(hd);
    l.push(max);
    if (sd) l.push(sd); /* ultimo recurso para trabones */
    return l.filter(function (u, i) { return u && l.indexOf(u) === i; });
  };

  /* Cambia la fuente conservando el segundo (t) y, si toca, reproduce. */
  Guard.prototype.poner = function (url, t, play) {
    var v = this.v, self = this;
    this.actual = url;
    if (t > 0.25) {
      v.addEventListener('loadedmetadata', function h() {
        v.removeEventListener('loadedmetadata', h);
        if (t < (v.duration || Infinity)) { try { v.currentTime = t; } catch (e) {} }
      });
    }
    v.src = url;
    if (play) this.play();
    else if (this.modo === 'full') this.clase(false);
    void self;
  };

  Guard.prototype.siguiente = function (motivo) {
    var l = this.lista, cur = this.actual, self = this, cand = null, k;
    var vivas = l.filter(function (u) { return !self.malas[u]; });
    if (motivo === 'trabado') {
      var liv = vivas.slice().sort(function (a, b) { return mbps(a) - mbps(b); })[0];
      if (liv && liv !== cur && mbps(liv) < mbps(cur)) cand = liv;
      return cand;
    }
    var i = l.indexOf(cur);
    for (k = i + 1; k < l.length; k++) if (!self.malas[l[k]]) { cand = l[k]; break; }
    if (!cand) for (k = 0; k < i; k++) if (!self.malas[l[k]]) { cand = l[k]; break; }
    return cand;
  };

  Guard.prototype.fallo = function (motivo) {
    var v = this.v, t = v.currentTime || 0;
    if (this.muerto) return;
    if (motivo === 'error') this.malas[this.actual] = true;
    var quiere = this.quiere();
    var cand = this.siguiente(motivo);
    if (cand) { this.poner(cand, t, quiere); return; }
    if (this.recargas < 1) { this.recargas++; this.poner(this.actual, t, quiere); return; }
    if (motivo === 'error') this.morir();
    /* trabado sin nada mas liviano y ya recargado: se deja al navegador seguir cargando */
  };

  Guard.prototype.morir = function () {
    this.muerto = true;
    if (this.modo === 'full') { this.caja.classList.remove('is-playing'); this.caja.classList.add('is-blocked'); }
    else if (!this.v.controls) this.v.setAttribute('controls', '');
  };

  Guard.prototype.quiere = function () {
    if (document.hidden) return false;
    return this.modo === 'full' ? this.want : this.intent;
  };

  Guard.prototype.armar = function () {
    var self = this;
    if (this.timer || this.muerto || !this.quiere()) return;
    this.timer = setTimeout(function () {
      self.timer = 0;
      var v = self.v;
      if (!self.quiere()) return;
      if (v.readyState >= 3 && !v.paused) return; /* se recupero solo */
      self.trabones++;
      if (self.trabones > 3) return;
      self.fallo('trabado');
    }, TRABON_MS);
  };
  Guard.prototype.desarmar = function () { if (this.timer) { clearTimeout(this.timer); this.timer = 0; } };

  Guard.prototype.play = function () {
    var v = this.v, self = this, p;
    try { p = v.play(); } catch (e) { return; }
    if (p && p.then) {
      p.then(function () { self.clase(true); }).catch(function (e) {
        var n = e && e.name;
        if (n === 'AbortError') return;            /* lo interrumpio una pausa nuestra */
        if (n === 'NotAllowedError') { if (self.modo === 'full') self.bloqueado(); return; }
        /* NotSupportedError u otro fallo de fuente: lo resuelve el evento 'error' */
      });
    } else { self.clase(true); }
  };
  Guard.prototype.parar = function () {
    var v = this.v;
    if (!v.paused) { this.pausaNuestra = true; v.pause(); }
  };
  Guard.prototype.bloqueado = function () {
    this.caja.classList.remove('is-playing'); this.caja.classList.add('is-blocked');
  };
  Guard.prototype.clase = function (playing) {
    if (this.modo !== 'full') return;
    if (playing) { this.caja.classList.add('is-playing'); this.caja.classList.remove('is-blocked'); }
    else this.caja.classList.remove('is-playing');
  };

  /* full: pausa ajena (Dawn, el sistema) con la caja a la vista -> reintenta */
  Guard.prototype.autocura = function () {
    var self = this;
    if (!this.quiere() || this.v.ended || this.curas >= 3) return;
    this.curas++; this.ultimaCura = Date.now();
    setTimeout(function () { if (self.quiere() && self.v.paused) self.play(); }, 350);
  };

  Guard.prototype.arrancar = function () {
    if (!this.actual) this.poner(this.lista[0], 0, false);
    if (quieto || ahorro) { this.bloqueado(); return; } /* respeta ahorro de datos / menos movimiento: play al toque */
    this.play();
  };

  Guard.prototype.vista = function (en) {
    this.enVista = en.isIntersecting;
    if (this.modo !== 'full') {
      if (this.enVista && this.reanudar && !document.hidden) { this.reanudar = false; this.play(); }
      return;
    }
    if (!en.isIntersecting) { this.want = false; this.parar(); return; }
    if (en.intersectionRatio >= 0.35 && !this.want) { this.want = true; this.arrancar(); }
  };

  Guard.prototype.visibilidad = function () {
    if (document.hidden) {
      if (!this.v.paused) { this.reanudar = true; this.parar(); }
      this.desarmar();
    } else if (this.reanudar) {
      this.reanudar = false;
      if (this.modo === 'full' ? this.want : this.enVista) this.play();
    }
  };

  Guard.prototype.toque = function (e) {
    var v = this.v;
    if (v.controls) return;
    var t = e.target;
    if (t && t.closest && t.closest('button:not([data-lu-vg-play]), a, [data-vs-sound]')) return;
    if (this.muerto) {
      this.muerto = false; this.malas = {}; this.recargas = 0; this.trabones = 0; this.curas = 0;
      this.caja.classList.remove('is-blocked');
      if (this.modo === 'full') this.want = true;
      this.poner(this.lista[0], 0, true);
      return;
    }
    if (this.caja.classList.contains('is-blocked')) this.caja.classList.remove('is-blocked');
    if (v.paused) { if (this.modo === 'full') this.want = true; this.play(); }
  };

  function init() {
    var vids = document.querySelectorAll('video[data-lu-vg]');
    for (var i = 0; i < vids.length; i++) {
      if (!vids[i].__luVG) { vids[i].__luVG = true; new Guard(vids[i]); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
